// Error codes
export const NO_VOTE = 'noVote';
